import axios from "@/plugins/axios";

let url = "/api/plugins/coturn/credentials";

export const credentials = {
    postGenerate(data) {
        return axios.post(`${url}/generate`, data).then((result) => result.data);
    },
};

export default credentials;
